export default __webpack_public_path__ + "static/media/Nitrox.f85089f7.jpeg";